import { render, staticRenderFns } from "./HomeB.vue?vue&type=template&id=77ac9b7e&"
import script from "./HomeB.vue?vue&type=script&lang=js&"
export * from "./HomeB.vue?vue&type=script&lang=js&"
import style0 from "./HomeB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports